export default "__VITE_ASSET__DtX9RtUk__"